import { MoneyInput } from '../../components/MoneyInput/MoneyInput';
import { signKr } from '../../lib/format';
import type { Item } from '@budgetx/shared';
import styles from './ItemRow.module.css';

interface Props {
  item: Item;
  month: number;
  isSavings: boolean;
  isIncome: boolean;
  onRename(name: string): void;
  onBudgetChange(next: number): void;
  onActualChange(next: number | null): void;
  onDelete(): void;
}

export function ItemRow({
  item,
  month,
  isSavings,
  isIncome,
  onRename,
  onBudgetChange,
  onActualChange,
  onDelete,
}: Props) {
  const b = item.budgets[month] ?? 0;
  const a = item.actuals[month] ?? null;
  const diff = isIncome ? (a ?? 0) - b : b - (a ?? 0);
  const diffText = isSavings ? '±0 kr.' : signKr(diff);
  const diffClass = isSavings ? styles.diffNeutral : diff < 0 ? styles.diffOver : styles.diffOk;

  return (
    <div className={styles.row}>
      <input
        className={styles.nameInput}
        value={item.name}
        onChange={(e) => onRename(e.target.value)}
        onFocus={(e) => e.target.select()}
      />
      <MoneyInput value={b} text onCommit={(v) => onBudgetChange(v ?? 0)} />
      <MoneyInput value={a} text onCommit={(v) => onActualChange(v)} />
      <div className={`${styles.diff} ${diffClass}`}>{diffText}</div>
      <button className={styles.delete} onClick={onDelete} title="Slet postering">
        ×
      </button>
    </div>
  );
}
